var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileysPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM10.418 5C10.8323 5 11.168 5.44767 11.168 6C11.168 6.55233 10.8323 7 10.418 7C10.0036 7 9.66797 6.55233 9.66797 6C9.66797 5.44767 10.0036 5 10.418 5ZM6.49667 6C6.49667 5.44733 6.16167 5 5.74833 5C5.335 5 5 5.44733 5 6C5 6.55267 5.33333 7 5.74833 7C6.16333 7 6.49667 6.55267 6.49667 6ZM8.00781 9.67585C9.40471 9.67585 10.6679 9.37379 11.5751 9.15684C12.4612 8.94493 13.0078 8.81422 13.0078 9.12552C13.0078 11.8869 10.7692 14.1255 8.00781 14.1255C5.24639 14.1255 3.00781 11.8869 3.00781 9.12552C3.00781 8.81422 3.5544 8.94493 4.44055 9.15684L4.44055 9.15684C5.34778 9.37379 6.61092 9.67585 8.00781 9.67585ZM11.0959 10.1327C10.3975 10.3154 9.32697 10.5955 8 10.5955C6.67303 10.5955 5.60251 10.3154 4.90407 10.1327C4.32349 9.98075 4 9.8961 4 10.0955C4 12.0095 6.908 12.0955 8 12.0955C9.226 12.0955 12 12.0092 12 10.0955C12 9.8961 11.6765 9.98075 11.0959 10.1327Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileysPeople);
export default __webpack_public_path__ + "static/media/smileys_people.76134810d4ce4450cb604ad36c6219ea.svg";
export { ForwardRef as ReactComponent };